import React from "react";
import {LiveCasinoVideoComponent} from "../../../../../components/live-casino-video/live-casino-video.component";
import {Check} from "@sparkware/app-utils";
import {SwiperListBaseModel} from "../swiper-list-base.model";
import {LiveStreamingListTitleBox} from "../../../../../components/live-streaming-tile/boxes/live-streaming-list-title/live-streaming-list-title.box";
import {LiveStreamingTitleIconBox} from "../../../../../components/live-streaming-tile/boxes/live-streaming-title-icon/live-streaming-title-icon.box";
import {LIVE_STREAMING_ITEM} from "../../../../../themes/css-global-classes";
import {ISwipeLogicHandler} from "../../swiper-logic-handler/swiper-logic-handler.interface";
import {LiveStreamSwipeLogicHandler} from "../../swiper-logic-handler/live-stream-swipe-logic-handler";
import {LiveStreamingNavigationPrevButtonBox, LiveStreamingNavigationNextButtonBox, LiveStreamingLeftCutBox, LiveStreamingRightCutBox} from "../../../../../components/live-streaming-tile/boxes/live-streaming-navigation/live-streaming-navigation.box";
import { computed } from "mobx";

// Temporarily disabling the live stream offset feature
// Because it wasnt working properly & product wanted to push a game as 1st always for a promo.

//const LIVE_STREAM_GAMETYPES_OFFSET_STORAGE_KEY = "orbit-live-stream-gametypes-offset";

export class LiveCasinoVideoListModel extends SwiperListBaseModel {

    // HELPER for gametypes:
    // 2330093 is Adventures Beyond Wonderland
    // 2010163 is Crazy Time
    // 2330162 is Mega Fire Blaze Roulette
    // 2010013 is 888 Roulette
    // 2330030 is Age of Gods Roulette
    // 2010033 is Live Lighting Roulette
    // 2330017 is Quantum Roulette
    // 2010015 is Ruby Roulette
    // 2330187 Safari Riches Live Slot
    // 2330140 888 Sports Roulette
    private _baseGameTypesArray = [2330187, 2330093, 2010163, 2330162, 2010013, 2010033, 2330017, 2010015, 2330140];

    protected _swipeLogicHandler: ISwipeLogicHandler = new LiveStreamSwipeLogicHandler(this.services, this);

    protected get _isAISorted(): boolean {
        return false;
    }

    private _isLiveStreamDisabled = () => {
        // live stream should be rendered on mobile only, excepting CIP8, if is enable from AB and
        // if user is authorized or if is not authorized only if is not disabled prelogin
        return this.services.miniOrbit.isEnabled ||
            !this.services.abTestingFeatureDataProvider.isVideoLiveStreamEnabled ||
            this.services.httpLiveStream.isDisabledPrelogin
    }

    get maxGamesToShowInList(): number {
        return 9;
    }

    // private _getGameTypesOffsetFromLocalStorage(): number {
    //     let storedValue = this.services.storage.getItem(LIVE_STREAM_GAMETYPES_OFFSET_STORAGE_KEY);
    //
    //     return Check.isNullOrUndefined(storedValue) ? 0 : parseInt(storedValue);
    // }
    //
    // private _gameTypesOffset: number = 0;

    protected _getGameTypes(): number[] {

        if(!Check.isNullOrUndefined(this.services.httpLiveStream.isSupported)
            && !this.services.httpLiveStream.isSupported) {
            return [];
        }

        //let baseArray = [...this._baseGameTypesArray];
        // if(Check.isNullOrUndefined(this._gameTypesOffset)){
        //     this._gameTypesOffset = this._getGameTypesOffsetFromLocalStorage();
        //     let newOffset = (this._gameTypesOffset + 1) % (this._baseGameTypesArray.length);
        //     this.services.storage.setItem(LIVE_STREAM_GAMETYPES_OFFSET_STORAGE_KEY, newOffset);
        // }
        //
        // let gameTypes = baseArray.splice(this._gameTypesOffset)
        //                 .concat(baseArray);

        let gameTypes = this._baseGameTypesArray;

        if(this.services.liveTableFeeds.tablesData.length === 0) {
            return gameTypes;
        } else {
            return gameTypes.filter(gType => this.services.liveTableFeeds.openTablesIds.find(tableId => tableId === gType.toString()));
        }
    }

    @computed
    get gameTypes(): number[] {
        // gameTypes is a getter and in javascript I cannot call "super.gameTypes"
        let gTypes = this._applyGameTypesTransformations(this._getGameTypes());

        if (this.services.mediaQuery.xlAndAbove && gTypes.length > 2) {
            let lastGame = gTypes.pop();
            gTypes.unshift(lastGame);
        }
        return gTypes;
    }

    protected _shouldBeDisplayed(): boolean {
        if(this._isLiveStreamDisabled()) {
            return false;
        }

        return super._shouldBeDisplayed() && this.gameTypes.length > 0;
    }

    _renderList(listPosition: number): React.ReactElement | null {
        return (<LiveCasinoVideoComponent key={this.listKey} viewModel={this} listPosition={listPosition}/>);
    }

    protected _renderHeaderIcon(): React.ReactElement | null {
        return (
            <LiveStreamingTitleIconBox>LIVE</LiveStreamingTitleIconBox>
        );
    }

    protected _renderHeaderText(): string | React.ReactElement {
        return (
            <LiveStreamingListTitleBox>
                {this.title.translation}
            </LiveStreamingListTitleBox>
        );
    }

    get numberOfGamesSkeletons(): number {
        return this._getNumberOfGamesSkeletons();
    }

    protected _getNumberOfGamesSkeletons(): number {
        if(Check.isNullOrUndefined(this.services.httpLiveStream.isSupported) || this.services.liveTableFeeds.tablesData.length === 0) {
            return 1;
        }

        return 0;
    }

    get templateType(): string {
        return LIVE_STREAMING_ITEM;
    }

    renderListNavigation(): React.ReactElement | null {

        const PrevIcon = this.services.theme.currentTheme.icons.leftArrowIcon;
        const NextIcon = this.services.theme.currentTheme.icons.rightArrowIcon;

        return (
            <React.Fragment>
                {this.services.mediaQuery.xlAndAbove ?
                    <LiveStreamingLeftCutBox>
                        <svg width="20" height="100%" viewBox="0 0 20 357">
                            <defs>
                                <filter id="Rectangle_1662" x="0" y="0" width="20" height="357" filterUnits="userSpaceOnUse">
                                <feOffset dx="4" dy="3" />
                                <feGaussianBlur stdDeviation="3" result="blur"/>
                                <feFlood/>
                                <feComposite operator="in" in2="blur"/>
                                <feComposite in="SourceGraphic"/>
                                </filter>
                            </defs>
                            <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Rectangle_1662)">
                                <rect id="Rectangle_1662-2" data-name="Rectangle 1662" width="2" height="339" transform="translate(5 6)" fill="#262626"/>
                            </g>
                        </svg>
                    </LiveStreamingLeftCutBox>
                : null}
                <LiveStreamingNavigationPrevButtonBox isActive={this.swipeLogicHandler.allowPrevious} onClick={() => this.swipeLogicHandler.movePrevious()}>
                    <PrevIcon size={3} style={{position: "absolute", top: "40%", left: "35%"}} />
                </LiveStreamingNavigationPrevButtonBox>
                <LiveStreamingNavigationNextButtonBox isActive={this.swipeLogicHandler.allowNext} onClick={() => this.swipeLogicHandler.moveNext()}>
                    <NextIcon size={3} style={{position: "absolute", top: "40%", right: "35%"}} />
                </LiveStreamingNavigationNextButtonBox>
                {this.services.mediaQuery.xlAndAbove ?
                    <LiveStreamingRightCutBox>
                        <svg width="20" height="100%" viewBox="0 0 20 357">
                            <defs>
                                <filter id="Rectangle_1663" x="0" y="0" width="20" height="357" filterUnits="userSpaceOnUse">
                                <feOffset dx="-4" dy="3" />
                                <feGaussianBlur stdDeviation="3" result="blur"/>
                                <feFlood/>
                                <feComposite operator="in" in2="blur"/>
                                <feComposite in="SourceGraphic"/>
                                </filter>
                            </defs>
                            <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Rectangle_1663)">
                                <rect id="Rectangle_1663-2" data-name="Rectangle 1663" width="2" height="339" transform="translate(13 6)" fill="#262626"/>
                            </g>
                        </svg>
                    </LiveStreamingRightCutBox>
                : null}
            </React.Fragment>
        );
    }
}
